import { Link, useNavigate } from "react-router-dom";
import { Error, Success } from "../../Components/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { changePasswordSchema } from "../../Schema/profileSchema";
import { changePassword } from "../../Services/Profile";
import { useMutation } from "react-query";
import Button from "../../Components/Button";
import { useState } from "react";
import BackButton from "../../Components/BackButton";

export default function ChangePassword() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(changePasswordSchema),
    });

    const { mutate, isLoading } = useMutation((data) => changePassword(data), {
        retry: false,
        onSuccess: (res) => {
            Success("Change Password", res.data?.message);
            navigate("/profile");
        },
        onError: (err) => {
            Error(err.response.data?.message);
        },
    });

    const submit = (data) => {
        mutate({
            currentPassword: data?.password,
            newPassword: data?.confirmPassword,
        });
    };

    const togglePassword = (field) => {
        setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="configuration">
                        <div className="user-details-wrapper">
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="back-title">
                                        <BackButton />
                                        <h1 className="pageTitle m-0">Change Password</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-10 col-xl-8">
                                    <div className="details-card-premium p-4 p-lg-5">
                                        <form onSubmit={handleSubmit(submit)}>
                                            <div className="mainDetail">
                                                <label className="mainLabel">Existing Password <span className="text-danger">*</span></label>
                                                <div className="flex-grow-1 position-relative">
                                                    <input
                                                        type={showPassword.currentPassword ? "text" : "password"}
                                                        className="dashInput pe-5"
                                                        placeholder="Enter Existing Password"
                                                        {...register("password")}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="passDisplay position-absolute end-0 top-50 translate-middle-y me-3 border-0 bg-transparent text-muted"
                                                        style={{ cursor: 'pointer', outline: 'none', transition: 'color 0.2s' }}
                                                        onClick={() => togglePassword('currentPassword')}
                                                        onMouseEnter={(e) => e.target.style.color = '#fb9809'}
                                                        onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                                                    >
                                                        <i className={showPassword.currentPassword ? "fas fa-eye" : "fas fa-eye-slash"} style={{ fontSize: '18px' }} />
                                                    </button>
                                                    {errors?.password && <span className="text-danger small d-block mt-1">{errors?.password?.message}</span>}
                                                </div>
                                            </div>

                                            <div className="mainDetail">
                                                <label className="mainLabel">New Password <span className="text-danger">*</span></label>
                                                <div className="flex-grow-1 position-relative">
                                                    <input
                                                        type={showPassword.newPassword ? "text" : "password"}
                                                        className="dashInput pe-5"
                                                        placeholder="Enter New Password"
                                                        {...register("newPassword")}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="passDisplay position-absolute end-0 top-50 translate-middle-y me-3 border-0 bg-transparent text-muted"
                                                        style={{ cursor: 'pointer', outline: 'none', transition: 'color 0.2s' }}
                                                        onClick={() => togglePassword('newPassword')}
                                                        onMouseEnter={(e) => e.target.style.color = '#fb9809'}
                                                        onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                                                    >
                                                        <i className={showPassword.newPassword ? "fas fa-eye" : "fas fa-eye-slash"} style={{ fontSize: '18px' }} />
                                                    </button>
                                                    {errors?.newPassword && <span className="text-danger small d-block mt-1">{errors?.newPassword?.message}</span>}
                                                </div>
                                            </div>

                                            <div className="mainDetail">
                                                <label className="mainLabel">Confirm Password <span className="text-danger">*</span></label>
                                                <div className="flex-grow-1 position-relative">
                                                    <input
                                                        type={showPassword.confirmPassword ? "text" : "password"}
                                                        className="dashInput pe-5"
                                                        placeholder="Confirm Password"
                                                        {...register("confirmPassword")}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="passDisplay position-absolute end-0 top-50 translate-middle-y me-3 border-0 bg-transparent text-muted"
                                                        style={{ cursor: 'pointer', outline: 'none', transition: 'color 0.2s' }}
                                                        onClick={() => togglePassword('confirmPassword')}
                                                        onMouseEnter={(e) => e.target.style.color = '#fb9809'}
                                                        onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                                                    >
                                                        <i className={showPassword.confirmPassword ? "fas fa-eye" : "fas fa-eye-slash"} style={{ fontSize: '18px' }} />
                                                    </button>
                                                    {errors?.confirmPassword && <span className="text-danger small d-block mt-1">{errors?.confirmPassword?.message}</span>}
                                                </div>
                                            </div>

                                            <div className="mt-5 text-end">
                                                <Button
                                                    type="submit"
                                                    className="siteBtn px-5"
                                                    loading={isLoading}
                                                >
                                                    Update Password
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
